'use client';

import { useCallback, useEffect, useState } from 'react';

/** Client-side pause before the reset e-mail can be requested again. */
export const RESEND_COOLDOWN_SECONDS = 60;

/** Seconds left until the pause ends, as „m:ss“ (Figma „Znova môžete poslať o 0:45“). */
export function formatCountdown(seconds: number) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}

export function useResendCooldown(running: boolean) {
  const [readyAt, setReadyAt] = useState(() =>
    running ? Date.now() + RESEND_COOLDOWN_SECONDS * 1000 : 0,
  );
  const [now, setNow] = useState(() => Date.now());
  const remaining = Math.max(0, Math.ceil((readyAt - now) / 1000));
  const active = remaining > 0;

  useEffect(() => {
    if (!active) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [active]);

  const restart = useCallback(() => {
    const current = Date.now();
    setNow(current);
    setReadyAt(current + RESEND_COOLDOWN_SECONDS * 1000);
  }, []);

  return { remaining, restart };
}
